import { render, staticRenderFns } from "./email-verification-page.vue?vue&type=template&id=5d1a08f3"
import script from "./email-verification-page.vue?vue&type=script&lang=js"
export * from "./email-verification-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports